import { SearchBarTheme as SearchBarDefaultTheme } from "@acin.reactjs/acin-ui/searchBar";
import { DefaultTheme } from "styled-components";
import { AppMediaQueries } from "./BreakpointsTheme";

const SearchBarTheme = (theme: DefaultTheme): SearchBarDefaultTheme => ({
  innerRoot: {
    root: {
      minHeight: "32px",

      [AppMediaQueries.maxTablet]: {
        minHeight: "40px",
      },
    },
  },
  dateRangePicker: {
    input: {
      minHeight: "30px",
      height: "30px",
      "& input": {
        minWidth: "166px",
        margin: "0px",

        [AppMediaQueries.maxTablet]: {
          minWidth: "170px",
        },

        [AppMediaQueries.maxMobile]: {
          minWidth: "186px",
        },
      },
    },
    calendar: {
      dayPicker: {
        day: {
          focusedLast: {
            color: theme.palette.common.white,
          },
        },
      },
      yearPicker: {
        year: {},
      },
    },
  },
  datePicker: {
    input: {
      minHeight: "30px",
      height: "30px",

      "& input": {
        margin: "0px",
        width: "100px",
      },
    },
  },
  searchIcon: {
    root: {
      "& svg path[stroke]:not([stroke='none'])": {
        stroke: theme.palette.common.black,
      },
    },
  },
});

export default SearchBarTheme;
